import {Component, OnInit} from '@angular/core';
import {SettingsTabs} from '../../enums/settings-enums';
import {PAGES_AND_PATHS} from '../../constants/pages-and-paths';
import {SubscriptionPlanTabsEnums} from '../../enums/subscription-enums';
import {PaymentHttpService} from '../../services/http-services/payment/payment-http.service';
import {AuthenticationHelperService} from "../../services/helpers/authentication-helper.service";
import {UserRoles} from "../../enums/general-enums";

@Component({
  selector: 'tl-settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent implements  OnInit{
  activeTab: SettingsTabs = SettingsTabs.insights;
  isAccountDropdownOpen = false;
  subscriptionPlanActiveTab: string = SubscriptionPlanTabsEnums.plans;
  insightsActiveTabIndex = true;
  usedSubscriptionPlan: any;
  profileData: any;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly SettingsTabs = SettingsTabs;
  protected readonly SubscriptionPlanTabsEnums = SubscriptionPlanTabsEnums;

  constructor(private paymentHttpService: PaymentHttpService,
              public authHelperService: AuthenticationHelperService) {
  }
  ngOnInit(): void {
    this.profileData = this.authHelperService.getUserData;
    if (this.authHelperService.checkActiveSubscription(this.profileData?.subscriptions) === UserRoles.expert || this.authHelperService.checkActiveSubscription(this.profileData?.subscriptions) === UserRoles.company) {
      this.activeTab = SettingsTabs.insights;
    } else {
      this.isAccountDropdownOpen = true;
      this.activeTab = SettingsTabs.changeUsername;
    }
    this.getCurrentSubscriptionPlan();
  }

  onPlanUpdate(): void {
    this.getCurrentSubscriptionPlan();
    this.subscriptionPlanActiveTab = SubscriptionPlanTabsEnums.plans;
  }

  getCurrentSubscriptionPlan(): void {
    this.paymentHttpService.getCurrentSubscriptionPlan().then((res: any) => {
      this.usedSubscriptionPlan = res.data;
    });
  }

  protected readonly UserRoles = UserRoles;
}
